import WebServiceRequest from '../Api/WebServiceRequest'

class PsychologicalTestGetLightListRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('PsychologicalTest/GetLightList')
    }
}
class PsychologicalTestAnswerGetPersonalityTestTypes extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('PsychologicalTestAnswer/GetPersonalityTestTypes')
    }
}

export {
    PsychologicalTestGetLightListRequest,
    PsychologicalTestAnswerGetPersonalityTestTypes
}